import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import { NavigationProvider } from "./context/NavigationContext";
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <NavigationProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </NavigationProvider>
    </ThemeProvider>
  </StrictMode>
);
